module.exports = "<div class=\"footer font\">\r\n  <span class=\"text-center\">© 2019 Copyright <a href=\"https://www.edsoncamargo.com.br/\"\r\n      target=\"_blank\">www.edsoncamargo.com.br</a>\r\n    <br> All rights reserved.</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/footer/footer.component.html
// module id = ./src/app/pages/footer/footer.component.html
// module chunks = main